import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles.module.scss";
import Button from "../../common/Button";
import { ModalActions } from "src/redux/Modal/actions";
import * as base32 from "hi-base32";
import * as secureRandom from "secure-random";
import { SettingsActions } from "src/redux/Settings/actions";
import { SettingsSelectors } from "src/redux/Settings/selectors";

const ConfirmResetSecretKey = (props) => {
    const dispatch = useDispatch();
    const selectedPeerCpty = useSelector(
        SettingsSelectors.SelectedPeerCptySetting
    );
    const handleResetSecretKey = () => {
        let input = secureRandom(32);
        let newSecret = base32.encode(input).slice(0, 16);
        const newCptySetting = {
            secret: newSecret,
            cptyCode: selectedPeerCpty?.cptyCode,
            name: selectedPeerCpty?.cptyName || selectedPeerCpty?.name,
            unregistered:
                selectedPeerCpty?.isUnregisteredCpty ||
                selectedPeerCpty?.unregistered,
            defaultObjective: selectedPeerCpty?.defaultObjective,
            emails: selectedPeerCpty?.emails,
        };
        dispatch(SettingsActions.ResetSecretKey(newCptySetting));
    };
    return (
        <Fragment>
            <div className={styles.confirmResetSecretKeyWrapper}>
                <div className={styles.subTitle}>
                    <p>
                        Resetting your Lenders Secret Key will mean that all of
                        the Lenders traders will need to setup their devices
                        again.
                    </p>
                </div>
                <div className={styles.subTitle}>
                    You should refresh Secret Keys if your Lender has reported a
                    lost/stolen devices, or if a trader has left.
                </div>
                <div className={styles.confirmResetSecretFooterText}>
                    This keeps your account secure by ensuring that only your
                    intended recipients are able to respond to your locates.
                </div>

                <div className={styles.confirmResetSecretKeyActionButtons}>
                    <Button
                        onClick={() => dispatch(ModalActions.Close())}
                        color="reversedWhite"
                        value="Cancel"
                        dataTestId="cancel-reset-secret-key"
                    />
                    <Button
                        onClick={handleResetSecretKey}
                        color="reversedWhite"
                        value="Reset"
                        dataTestId="reset-secret-key"
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default ConfirmResetSecretKey;
